<template>
  <div class="ai-context-settings-tab" data-testid="ai-context-settings">
    <div class="ai-context-settings-tab__toolbar d-flex align-center">
      <base-button
        primary
        label="Create Group"
        data-testid="ai-context-settings__create-btn"
        @click="openCreate"
      />
    </div>

    <div class="ai-context-settings-tab__table flex-fill-table">
      <AiContextGroupsTable
        :items="pagedGroups"
        :filter-source-items="contextGroups"
        :loading="loading"
        :page="currentPage"
        :items-per-page="itemsPerPage"
        @edit="openEdit"
        @update:filters="onTableFilters"
      />
    </div>

    <Pagination
      v-if="!loading"
      v-model="pageOneBased"
      :list="filteredGroups"
      :itemsperpage="itemsPerPage"
      :hide-on-single-page="false"
      data-testid="ai-context-settings__pagination"
    />

    <AiContextGroupDialog
      v-model="dialogOpen"
      :mode="dialogMode"
      :group="selectedGroup"
      @saved="onSaved"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Pagination from '@/views/common/Pagination.vue';
import { filterContextGroups } from '../../../utils/aiContextHelpers';
import AiContextGroupsTable from './AiContextGroupsTable.vue';
import AiContextGroupDialog from './AiContextGroupDialog.vue';

export default {
  name: 'AiContextSettingsTab',
  components: {
    Pagination,
    AiContextGroupsTable,
    AiContextGroupDialog,
  },
  data() {
    return {
      dialogOpen: false,
      dialogMode: 'create',
      selectedGroup: null,
      pageOneBased: 1,
      itemsPerPage: 10,
      tableFilters: {},
    };
  },
  computed: {
    ...mapGetters('varianceanalysis/contextGroups', [
      'contextGroups',
      'contextGroupsLoading',
    ]),
    loading() {
      return this.contextGroupsLoading;
    },
    filteredGroups() {
      return filterContextGroups(this.contextGroups || [], this.tableFilters);
    },
    currentPage() {
      return Math.max(0, (this.pageOneBased || 1) - 1);
    },
    pagedGroups() {
      const start = this.currentPage * this.itemsPerPage;
      return this.filteredGroups.slice(start, start + this.itemsPerPage);
    },
  },
  mounted() {
    this.refresh();
  },
  beforeDestroy() {
    this.$store.commit('varianceanalysis/contextGroups/CLEAR_CONTEXT_GROUPS_STATE');
  },
  methods: {
    async refresh() {
      try {
        await this.$store.dispatch('varianceanalysis/contextGroups/fetchContextGroups', {
          axios: this.axios,
          page: 0,
          limit: 100,
          client: this.$store.state.client,
        });
        this.pageOneBased = 1;
      } catch (e) {
        // handled in store
      }
    },
    onTableFilters(filters = {}) {
      // Clone so each Apply gets a new reactive object (combined filters recompute reliably)
      const next = {};
      Object.keys(filters || {}).forEach((key) => {
        next[key] = Array.isArray(filters[key]) ? [...filters[key]] : filters[key];
      });
      this.tableFilters = next;
      this.pageOneBased = 1;
    },
    openCreate() {
      this.dialogMode = 'create';
      this.selectedGroup = null;
      this.dialogOpen = true;
    },
    openEdit(item) {
      this.dialogMode = 'edit';
      this.selectedGroup = { ...item };
      this.dialogOpen = true;
    },
    onSaved() {
      this.refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AiContextSettingsTab.scss';
</style>
